import { z } from 'zod';

export const AuthMaterialExpirySchema = z.object({
  expiresAt: z.iso.datetime().nullable(),
  source: z.enum(['jwt', 'cookie', 'cache_ttl', 'unknown']),
  status: z.enum(['valid', 'expiring_soon', 'expired', 'unknown']),
  computedAt: z.iso.datetime(),
});

export const AuthMaterialArtifactKindSchema = z.enum([
  'header',
  'cookie',
  'secret',
  'localStorage',
  'sessionStorage',
]);

export const CachedCredentialArtifactSummarySchema = z.object({
  kind: AuthMaterialArtifactKindSchema,
  name: z.string(),
  valuePreview: z.string(),
  expiresAt: z.iso.datetime().nullable().optional(),
});

export const GatheredArtifactUpdateSchema = z.object({
  kind: AuthMaterialArtifactKindSchema,
  name: z.string().min(1),
  value: z.string(),
  expiresAt: z.iso.datetime().nullable().optional(),
});

export const CachedCredentialSummarySchema = z.object({
  id: z.string(),
  gatheredAt: z.iso.datetime().nullable(),
  readiness: z.enum(['ready', 'reverify']),
  authMaterialExpiry: AuthMaterialExpirySchema.optional(),
  artifacts: z.array(CachedCredentialArtifactSummarySchema),
});

export const CachedCredentialsSummaryResponseSchema = z.object({
  credentials: z.array(CachedCredentialSummarySchema),
});

export const AuthenticatorBodySchema = z.object({
  applicationId: z.string().describe('Application ID'),
  role: z.string().describe('Role'),
  username: z.string().describe('Username'),
});

export const AuthenticatorReturnSchema = z.object({
  success: z.boolean().describe('Success'),
});

// Cached credentials schemas for replay tab auth header replacement
export const CachedCredentialHeaderSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const CachedCredentialCookieSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export const CachedCredentialSchema = z.object({
  id: z.string(),
  role: z.string(),
  username: z.string(),
  headers: z.array(CachedCredentialHeaderSchema),
  cookies: z.array(CachedCredentialCookieSchema),
  secrets: z.array(CachedCredentialHeaderSchema),
  fullBrowserStorage: z
    .object({
      localStorage: z.array(CachedCredentialHeaderSchema),
      sessionStorage: z.array(CachedCredentialHeaderSchema),
    })
    .optional(),
  authMaterialExpiry: AuthMaterialExpirySchema.optional(),
  isDisabled: z.boolean().optional(),
});

export const CachedCredentialsResponseSchema = z.object({
  credentials: z.array(CachedCredentialSchema),
});

export const CachedCredentialResponseSchema = z.object({
  credential: CachedCredentialSchema,
});

export const RefreshCredentialBodySchema = z.object({
  sessionId: z.string().describe('Browser session ID for authentication'),
});

export const RefreshCredentialResponseSchema = z.object({
  credential: CachedCredentialSchema,
  message: z.string().describe('Authentication result message'),
});
